// extracted by mini-css-extract-plugin
module.exports = {"defaultIconStyle":"az_dk","fontSizeInherit":"az_ek","fontSizeSmall":"az_fk","fontSizeLarge":"az_gk"};